import moment from 'moment';
import get from 'lodash/get';
import isString from 'lodash/isString';
import isNull from 'lodash/isNull';
import { applicationTypes } from '../../../values/application';

const DEFAULT_DATE_FORMAT = 'MM-DD-YYYY';

export const getters = {
  applicationType: state => state.applicationType,

  // primary applicant
  primaryApplicantDateOfBirthAsStringWithDashes: state =>
    isString(state.primary.dateOfBirth)
      ? moment(state.primary.dateOfBirth, DEFAULT_DATE_FORMAT).format(DEFAULT_DATE_FORMAT)
      : null,
  primaryApplicantDateOfBirthAsStringWithForwardSlashes: state =>
    isString(state.primary.dateOfBirth)
      ? moment(state.primary.dateOfBirth, DEFAULT_DATE_FORMAT).format('MM/DD/YYYY')
      : null,
  primaryApplicantDateOfBirthAsStringInUtcFormat: state =>
    isString(state.primary.dateOfBirth)
      ? moment(state.primary.dateOfBirth, DEFAULT_DATE_FORMAT).utc().format()
      : null,
  primaryApplicantEmailAddress: state => state.primary.emailAddress,
  primaryApplicantFirstName: state => state.primary.firstName,
  primaryApplicantLastName: state => state.primary.lastName,
  primaryApplicantMobileNumber: state => state.primary.mobileNumber,
  primaryApplicantSocialSecurityNumber: state => state.primary.ssn,

  // joint applicant
  jointApplicantDateOfBirthAsStringWithDashes: state =>
    isString(state.joint.dateOfBirth)
      ? moment(state.joint.dateOfBirth, DEFAULT_DATE_FORMAT).format(DEFAULT_DATE_FORMAT)
      : null,
  jointApplicantDateOfBirthAsStringWithForwardSlashes: state =>
    isString(state.joint.dateOfBirth)
      ? moment(state.joint.dateOfBirth, DEFAULT_DATE_FORMAT).format('MM/DD/YYYY')
      : null,
  jointApplicantDateOfBirthAsStringInUtcFormat: state =>
    isString(state.joint.dateOfBirth)
      ? moment(state.joint.dateOfBirth, DEFAULT_DATE_FORMAT).utc().format()
      : null,
  jointApplicantEmailAddress: state => state.joint.emailAddress,
  jointApplicantFirstName: state => state.joint.firstName,
  jointApplicantLastName: state => state.joint.lastName,
  jointApplicantMobileNumber: state => state.joint.mobileNumber,
  jointApplicantSocialSecurityNumber: state => state.joint.ssn,

  jointApplicantRelationshipToPrimaryApplicantIsNull: state =>
    isNull(state.joint.relationshipToPrimary),
  jointApplicantRelationshipToPrimaryApplicantTypeLabel: state =>
    get(state, 'joint.relationshipToPrimary.label', null),
  jointApplicantRelationshipToPrimaryApplicantTypeValue: state =>
    get(state, 'joint.relationshipToPrimary.value', null),

  hasJointApplicant: state => state.applicationType === applicationTypes.JOINT
};
